import axios from 'axios';
import React, { Component, useEffect } from 'react';
import S3FileUpload from 'react-s3/lib/ReactS3';
import * as FileSaver from 'file-saver';

class Analyze extends Component {
   
    constructor(props) {
        super(props)  
        this.state={
            pythonBody:{
                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                model:[]
            },
            classifyModel:[],
            colorModel:[],
            imgAlignment:[],
            Blank_ImprintSelected:false,
            ShotSelected:false,
            Single_MultiSelected:false,
            ColorSelected:false,
            imgAlignmentSelected:false,  
            selectedExcel:"",  
            excelError:"",
            msg:""   
            
            // selectedFiles : []
        }
        this.fileInputRef1 =React.createRef();
        this.uploadRef1=React.createRef();
        this.progressRef1=React.createRef();
        this.myRef = React.createRef();
        this.msgRef= React.createRef();      
    }
    dragOver= (e) =>{
        e.preventDefault();
    }
    dragEnter = (e) => {
        e.preventDefault();
    }
    dragLeave = (e) => {
        e.preventDefault(); 
    }
    fileDrop = (e) => {
        e.preventDefault(); 
        const files = e.dataTransfer.files;
        // console.log("files "+files);
        if (files.length) {
            this.handleFiles(files);
        }
    }
    handleFiles = (files) => {
        for(let i = 0; i < files.length; i++) {          
               this.setState({selectedFiles :prevArray => [...prevArray, files[i]]})
        }
    }
    removeFile = (name) => {       
        const index2 = this.state.selectedFiles.findIndex(e => e.name === name);
        this.state.selectedFiles.splice(index2, 1);
        this.setState({selectedFiles :[...this.state.selectedFiles]});
    }
    fileType = (fileName) => {
        return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
    }
    fileSize = (size) => {
        if (size === 0) {
          return '0 Bytes';
        }
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    fileInputClicked = () => {
        this.fileInputRef1.current.click();
    }
    filesSelected = () => {
        if (this.fileInputRef1.current.files.length) {
            this.handleFiles(this.fileInputRef1.current.files);
        }
    }
    onFileChange = event => { 
        // this.uploadRef1.current.innerHTML = 'File(s) Uploading...';
        this.props.selectedExcel(event.target.files[0])
        // this.setState({ selectedExcel: event.target.files[0] }); 
        // for (let i = 0; i < this.state.selectedFiles.length; i++) {
            
        // }
    }
    closeModal = () => {
       
        this.myRef.current.style.display = "none";
                this.msgRef.current.innerHTML = '';
       
    }
    onFileUpload = () => { 
        
        if(this.props.props.selectedExcel.type!=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
            // this.setState({excelError:"Please upload only excel files"});
            this.myRef.current.style.display = "block";
            this.msgRef.current.innerHTML = 'Please upload only excel files';
        }
        else{
            this.setState({excelError:""})
            // const formData = new FormData(); 
            // // Update the formData object 
            // formData.append( 
            //     "myFile", 
            //     this.props.props.selectedFile, 
            //     this.props.props.selectedFile.name 
            // );         
            // Details of the uploaded file 
            console.log(this.props.props.selectedExcel.name); 
            const configS3={
                bucketName:'pcna-images',
                // key:'zipFilename.zip',
                dirName:this.props.props.img_folder,
                region:'ap-south-1',
                accessKeyId:'AKIAU7MO6YSXATZ3BDEH',
                secretAccessKey:'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'           
            };            
            S3FileUpload.uploadFile(this.props.props.selectedExcel, configS3)
            .then(data =>{
            //    var  uploadPercentage1 = Math.floor((1) * 100);
            //    this.progressRef1.current.innerHTML = `${uploadPercentage1}%`;
            //    this.progressRef1.current.style.width = `${uploadPercentage1}%`;
                this.uploadRef1.current.innerHTML = 'File Uploaded..';
                this.progressRef1.current.innerHTML = '100%';
                this.progressRef1.current.style.width = '100%';  
                this.progressRef1.current.style.backgroundColor = 'green';  
               
                
                                     
            })
            .catch(err =>{
                
                
                this.uploadRef1.current.innerHTML = `<span class="error">Error Uploading File(s)</span>`;
                this.progressRef1.current.style.backgroundColor = 'red';
                // this.props.UpdateUploaded(false)
            } )
        }    
    }        
    selectModel(ModelName){
        if(ModelName=="Blank/Imprint"){
            if(this.state.Blank_ImprintSelected==true){ //remove selection
                var array = [...this.props.props.ModelName]; 
                var index = array.indexOf(ModelName)
                if (index !== -1) {
                  array.splice(index, 1);
                  this.props.selectedModel(array)
                }              
            }
            else{ //Is selected
                var arr=[...this.props.props.ModelName, ModelName]
                this.props.selectedModel(arr)
            }
            this.setState({Blank_ImprintSelected:!this.state.Blank_ImprintSelected})
            this.props.CheckBoxValue(ModelName,!this.state.Blank_ImprintSelected)
        } 
        else if(ModelName=="Shot"){
            if(this.state.ShotSelected==true){ //remove selection
                var array = [...this.props.props.ModelName]; 
                var index = array.indexOf(ModelName)
                if (index !== -1) {
                  array.splice(index, 1);
                  this.props.selectedModel(array)
                }              
            }
            else{ //Is selected
                var arr=[...this.props.props.ModelName, ModelName]
                this.props.selectedModel(arr)
            }
            this.setState({ShotSelected:!this.state.ShotSelected})
            this.props.CheckBoxValue(ModelName,!this.state.ShotSelected)
        } 
        else if(ModelName=="Single/Multi"){
            if(this.state.Single_MultiSelected==true){ //remove selection
                var array = [...this.props.props.ModelName]; 
                var index = array.indexOf(ModelName)
                if (index !== -1) {
                  array.splice(index, 1);
                  this.props.selectedModel(array)
                }              
            }
            else{ //Is selected
                var arr=[...this.props.props.ModelName, ModelName]
                this.props.selectedModel(arr)
            }
            this.setState({Single_MultiSelected:!this.state.Single_MultiSelected})
            this.props.CheckBoxValue(ModelName,!this.state.Single_MultiSelected)
        } 
        else if(ModelName=="dominant_colour"){ 
            this.setState({ColorSelected:!this.state.ColorSelected})
            this.props.CheckBoxValue(ModelName,!this.state.ColorSelected)
        }   
        else if(ModelName=="ImgComparison"){
            this.setState({imgAlignmentSelected:!this.state.imgAlignmentSelected})
            this.props.CheckBoxValue(ModelName,!this.state.imgAlignmentSelected)
        }     
    } 
    analyseClick(){
        
        //var url='http://ec2-65-0-72-165.ap-south-1.compute.amazonaws.com:8088'
        var url='http://ec2-65-0-82-36.ap-south-1.compute.amazonaws.com:8088'
        if(this.state.Blank_ImprintSelected==false && this.state.ShotSelected==false && this.state.Single_MultiSelected==false &&
            this.state.ColorSelected==false && this.state.imgAlignmentSelected==false){
                // alert('Please select atleast one model')
                this.myRef.current.style.display = "block";
                this.msgRef.current.innerHTML = 'Please select atleast one model';
                
            }
        else if(this.state.imgAlignmentSelected==true && (this.props.props.selectedExcel=="" && 
        this.props.props.selectedExcel.type=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ){
            // alert('Please upload the excel file')
            this.myRef.current.style.display = "block";
                this.msgRef.current.innerHTML = 'Please upload the excel file';
        }  
        else if(this.state.Blank_ImprintSelected==true || this.state.ShotSelected==true || this.state.Single_MultiSelected==true){            
            this.props.analyseClick(true)
            ///Classify start
            var paramsClassify={
                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                model:this.props.props.ModelName
            }  
            console.log(JSON.stringify(paramsClassify))
            axios.post(url+'/all_model',JSON.stringify(paramsClassify))
            .then((res)=>{ 
                               
                // console.log(res.data)
                this.setState({ classifyModel:res.data })
                this.props.classifyValues(res.data)

                ///color Model
                if(this.state.ColorSelected==true){
                    var paramsColor={
                        img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName
                    }  
                    axios.post(url+'/dominant_colour',JSON.stringify(paramsColor))
                    .then((resColor)=>{
                        console.log(resColor.data)
                        this.setState({ colorModel:resColor.data })
                        this.props.colorModel(resColor.data)

                        ////////////////image Alipgnment
                        if(this.state.imgAlignmentSelected==true){
                            var paramsAlign={
                                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                                Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                            }  
                            console.log(paramsAlign)
                            axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                            .then((resAlignment)=>{
                                
                                console.log(resAlignment.data)
                                this.setState({ imgAlignment:resAlignment.data })
                                this.props.imgAlignment(resAlignment.data)
                            })
                            .catch(err=>{
                               // alert('error in image Alignment')
                                this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in image Alignment';
                                console.log("error in imageAlignment",err)
                            }) 
                        }                        
                        ////////////////image Alipgnment
                    })
                    .catch(err=>{
                      //  alert('error in dominant color')
                        this.myRef.current.style.display = "block";
                        this.msgRef.current.innerHTML = 'error in dominant color';
                        console.log("error in dominant color",err)
                        ////////////////image Alipgnment
                        if(this.state.imgAlignmentSelected==true){
                            var paramsAlign={
                                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                                Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                            }  
                            console.log(paramsAlign)
                            axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                            .then((resAlignment)=>{
                                
                                console.log(resAlignment.data)
                                this.setState({ imgAlignment:resAlignment.data })
                                this.props.imgAlignment(resAlignment.data)
                            })
                            .catch(err=>{
                                // alert('error in image Alignment')
                                this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in image Alignment';
                                console.log("error in imageAlignment",err)
                            }) 
                        }
                        ////////////////image Alipgnment
                    }) 
                }
                ///color model

            })
            .catch(err=>{  
        
                // alert('error in classify Model')
                this.myRef.current.style.display = "block";
                this.msgRef.current.innerHTML = 'error in classify Model';
                console.log("error in classification",err)

                /////////////color Model
                if(this.state.ColorSelected==true){
                    var paramsColor={
                        img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName
                    }  
                    axios.post(url+'/dominant_colour',JSON.stringify(paramsColor))
                    .then((resColor)=>{
                        console.log(resColor.data)
                        this.setState({ colorModel:resColor.data })
                        this.props.colorModel(resColor.data)

                        ////////////////image Alipgnment
                        if(this.state.imgAlignmentSelected==true){
                            var paramsAlign={
                                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                                Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                            }  
                            console.log(paramsAlign)
                            axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                            .then((resAlignment)=>{
                                
                                console.log(resAlignment.data)
                                this.setState({ imgAlignment:resAlignment.data })
                                this.props.imgAlignment(resAlignment.data)
                            })
                            .catch(err=>{
                                this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in image Alignment';
                              //  alert('error in image Alignment')
                                console.log("error in imageAlignment",err)
                            }) 
                        }
                        ////////////////image Alipgnment
                    })
                    .catch(err=>{
                        // alert('error in dominant color')
                        this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in dominant color';
                        console.log("error in dominant color",err)
                        ////////////////image Alipgnment
                        if(this.state.imgAlignmentSelected==true){
                            var paramsAlign={
                                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                                Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                            }  
                            console.log(paramsAlign)
                            axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                            .then((resAlignment)=>{
                                
                                console.log(resAlignment.data)
                                this.setState({ imgAlignment:resAlignment.data })
                                this.props.imgAlignment(resAlignment.data)
                            })
                            .catch(err=>{
                                // alert('error in image Alignment')
                                this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in image Alignment';
                                console.log("error in imageAlignment",err)
                            }) 
                        }
                        ////////////////image Alipgnment
                    }) 
                }
                ///////////color model

            })
            ////classify Model
        }
        else if(this.state.ColorSelected==true){
            this.props.analyseClick(true)
            ///color Model
            if(this.state.ColorSelected==true){
                var paramsColor={
                    img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName
                }  
                axios.post(url+'/dominant_colour',JSON.stringify(paramsColor))
                .then((resColor)=>{
                    console.log(resColor.data)
                    this.setState({ colorModel:resColor.data })
                    this.props.colorModel(resColor.data)

                    ////////////////image Alipgnment
                    if(this.state.imgAlignmentSelected==true){
                        var paramsAlign={
                            img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                            Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                        }  
                        console.log(paramsAlign)
                        axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                        .then((resAlignment)=>{
                            
                            console.log(resAlignment.data)
                            this.setState({ imgAlignment:resAlignment.data })
                            this.props.imgAlignment(resAlignment.data)
                        })
                        .catch(err=>{
                            // alert('error in image Alignment')
                            this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in image Alignment';
                            console.log("error in imageAlignment",err)
                        }) 
                    }                        
                    ////////////////image Alipgnment
                })
                .catch(err=>{
                   // alert('error in dominant color')
                    this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in dominant color';
                    console.log("error in dominant color",err)
                    ////////////////image Alipgnment
                    if(this.state.imgAlignmentSelected==true){
                        var paramsAlign={
                            img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                            Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                        }  
                        console.log(paramsAlign)
                        axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                        .then((resAlignment)=>{
                            
                            console.log(resAlignment.data)
                            this.setState({ imgAlignment:resAlignment.data })
                            this.props.imgAlignment(resAlignment.data)
                        })
                        .catch(err=>{
                            // alert('error in image Alignment')
                            this.myRef.current.style.display = "block";
                                this.msgRef.current.innerHTML = 'error in image Alignment';
                            console.log("error in imageAlignment",err)
                        }) 
                    }
                    ////////////////image Alipgnment
                }) 
            }
            ///color model
        }
        else if (this.state.imgAlignmentSelected==true){
            
            this.props.analyseClick(true)
            ////////////////image Alipgnment            
                var paramsAlign={
                    img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                    Product_code:this.props.props.img_folder+"/"+this.props.props.selectedExcel.name
                }  
                console.log(paramsAlign)
                axios.post(url+'/img_alignment',JSON.stringify(paramsAlign))
                .then((resAlignment)=>{
                    
                    console.log(resAlignment.data)
                    this.setState({ imgAlignment:resAlignment.data })
                    this.props.imgAlignment(resAlignment.data)
                   
                })
                .catch(err=>{
                    
                   // alert('error in image Alignment')
                    this.myRef.current.style.display = "block";
                     this.msgRef.current.innerHTML = 'error in image Alignment';
                    console.log("error in imageAlignment",err)
                }) 
            }                        
            ////////////////image Alipgnment
    }  
    downloadTemplate(){
        
        FileSaver.saveAs("https://pcna-images.s3.ap-south-1.amazonaws.com/ExcelTemplate/Alignment_mapping_template.xlsx","Template.xlsx");
    }

    render() {
        return (   
                 <div className="analyze-c shadow">
          <div className="title">
               SELECT MODELS TO ANALYSE
               <br/>
               </div>
               <div className="row mt-1">
               <div className="col-md-12 title">
                   1.IMAGE ANALYSIS
               </div>
                   <div className="ml-3 form-check"><input type="checkbox" id="c1" onChange={()=>this.selectModel("Blank/Imprint")} disabled={!this.props.props.imagesUploaded}
                   className="form-check-input"/> <strong>  Black-lmprint</strong></div>
                   <div className="ml-3 form-check"><input type="checkbox" id="c2" onChange={()=>this.selectModel("Shot")} disabled={!this.props.props.imagesUploaded}
                    className="form-check-input" /> <strong>  Shot View</strong></div>
                   <div className="ml-3 form-check"><input type="checkbox" id="c2" onChange={()=>this.selectModel("Single/Multi")} disabled={!this.props.props.imagesUploaded}
                   className="form-check-input" /> <strong>  Single-Multi</strong></div>
                   <div className="ml-3 form-check"><input type="checkbox" id="c3" onChange={()=>this.selectModel("dominant_colour")} disabled={!this.props.props.imagesUploaded}
                   className="form-check-input"/> <strong>  Color Categorization</strong></div>
                   {/* <div className="ml-3 form-check"><input type="checkbox" id="c4" className="form-check-input"/> <strong>  Right Angled-Left Angled</strong></div> */}
                   </div> 
                   <div className="row mt-1">
               <div className="col-md-12 title">
                    2.IMAGE COMPARISON
               
               </div>
                   <div className="ml-3 form-check"><input type="checkbox" id="ac1" onChange={()=>this.selectModel("ImgComparison")} 
                   disabled={!this.props.props.imagesUploaded}
                   className="form-check-input"/> <strong>  Alignment</strong></div>

                    {this.state.imgAlignmentSelected==true?
                    <React.Fragment>
                        <div className="ml-3 sample-f mr-2"><img className="h-i-5" onClick={()=>this.downloadTemplate()} src="assets/media/logos/samplef.png"/><small> Sample File Download</small></div>
                        <input type="file" onChange={this.onFileChange} className="drop-message-c ml-4" /> 
                        <button onClick={this.onFileUpload} disabled={(this.props.props.selectedExcel==null)?true:false}
                         className={"file-upload-btn-c"} > 
				            Upload! 
				        </button>
                        <div className="ml-2">{this.state.excelError}</div>
                    {/* <div className="ml-3 sample-f"><img className="h-i-5" src="assets/media/logos/samplef.png"/><small> Sample File Download</small></div>
                    <div className="drop-container-c ml-6" onDragOver={ this.dragOver}  onDragEnter={this.dragEnter}
                    onDragLeave={this.dragLeave} onDrop={this.fileDrop} onClick={ this.fileInputClicked}   >
                    <div className="drop-message-c">
                        <img className="mr-2 h-i-5" src="assets/media/logos/attachment.svg" alt="attach" />
                        <b>Drag and Drop</b> or browse excel file
                    </div>
                    <input ref={this.fileInputRef1} className="file-input" type="file" onChange={this.filesSelected} />

                    </div>
                    <button className={"file-upload-btn-c"} onClick={() => this.onFileChange} 
                    disabled={(!this.props.props.imagesUploaded && this.selectedFile!=null)} display={'none'} >Upload</button> */}
                    </React.Fragment>
                    :""}
                  
                </div>
                <div className="modal" ref={this.myRef}>
                <div className="overlay"></div>
                <span className="close" onClick={(() => this.closeModal())}>X</span>
                <div className="progress-container1">
                {/* <h5  className=" alert alert-danger mt-6" ref={this.msgRef}></h5> */}
                <div className="alert alert-custom  alert-light-danger fade show " role="alert">
    <div className="alert-icon"><i className="flaticon-warning"></i></div>
    <div className="alert-text"  ref={this.msgRef}></div>
    <div className="alert-close">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={(() => this.closeModal())}>
            <span aria-hidden="true"><i className="ki ki-close"></i></span>
        </button>
    </div>
</div>
                </div>
                
                
            </div>
                   <div className="row card w-50">
                   <span className="card-header" ref={this.uploadRef1}></span>
                   <div className="card-body">
                 
                    <div className="progress ">
                        <div className="progress-bar" ref={this.progressRef1}></div>
                    </div>
                    </div> 
                </div>
                   <div className="row mt-2">
                       <div className="analyze-l">
                   <button className="btn btn-dark btn-lg mt-4 " onClick={()=>this.analyseClick()} 
                   disabled={!this.props.props.imagesUploaded } >ANALYSE</button>
                   {/* && 
                   (this.props.props.imgAlignmentSelected && this.props.props.selectedExcel!==null) ||
                   (this.props.props.Blank_ImprintSelected || this.props.props.ShotSelected || 
                    this.props.props.Single_MultiSelected || this.props.props.ColorSelected) */}
                   </div>
                       </div>                                                          

                 </div>      
            );
        }
    }
    export default Analyze;